<script>
    // https://svelte.dev/repl/4c5dfd34cc634774bd242725f0fc2dab?version=3.46.4
    import { openModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import { z } from 'zod';

    import { accountName } from '../../../stores/store';
    import IconUser from '../../shared/Icons/IconUser.svelte';
    import ModalHelp from '../../shared/Modals/ModalHelp.svelte';

    export let icon = '.';
    export let onLogout = () => {};

    let isDropdownOpen = false; // default state (dropdown close)
    let accountNameAbbreviation = '';

    const handleDropdownClick = () => {
        isDropdownOpen = !isDropdownOpen; // togle state on click
    };

    const handleDropdownFocusLoss = ({ relatedTarget, currentTarget }) => {
        // use "focusout" event to ensure that we can close the dropdown when clicking outside or when we leave the dropdown with the "Tab" button
        if (relatedTarget instanceof HTMLElement && currentTarget.contains(relatedTarget)) return; // check if the new focus target doesn't present in the dropdown tree (exclude ul\li padding area because relatedTarget, in this case, will be null)
        isDropdownOpen = false;
    };

    function displayHelpWindow() {
        isDropdownOpen = false;
        openModal(ModalHelp, {});
    }

    $: {
        if ($accountName && z.string().email().safeParse($accountName).success === true) {
            accountNameAbbreviation = $accountName
                .split('@')[0]
                .split('.')
                .map(s => {
                    return s.slice(0, 1);
                })
                .slice(0, 2)
                .join('');
        } else {
            accountNameAbbreviation = '';
        }
    }
</script>

<div class="menu-dropdown-container">
    <div class="dropdown" on:focusout={handleDropdownFocusLoss}>
        <button class="btn-menu" on:click={handleDropdownClick}>
            <!--{icon}-->
            {#if accountNameAbbreviation !== ''}
                {accountNameAbbreviation}
            {:else}
                <IconUser />
            {/if}
        </button>
        <div class="menu-list" style:visibility={isDropdownOpen ? 'visible' : 'hidden'}>
            <button class="menu-element disabled" on:click={() => {}}>{$accountName}</button>
            <button class="menu-element" on:click={displayHelpWindow}>
                <!--                <span class="menu-element-icon">-->
                <!--                    <WhiteColor>-->
                <!--                        <IconHelpCenter scale={0.7} />-->
                <!--                    </WhiteColor>-->
                <!--                </span>-->
                {$_('help_and_support')}
            </button>
            <div class="separator"></div>
            <button class="menu-element" on:click={onLogout}>{$_('Logout')}</button>
        </div>
    </div>
</div>

<style>
    :root {
        --menu-background: #6c6b6a;
        --menu-color: #ffffff;
    }
    .menu-dropdown-container {
        z-index: 100;
        /*z-index: 1000;*/
    }
    .menu-element {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        column-gap: 5px;
    }
    .menu-list {
        padding: 10px;
        background-color: var(--menu-background);
        color: var(--menu-color);
        border-radius: 6px;
        font-size: 13px;
        position: absolute;
        right: 0;
        top: 39px;
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
    }
    .menu-list .disabled {
        cursor: default;
        opacity: 0.7;
    }
    .menu-list button {
        list-style: none;
        color: white;
        min-width: 150px;
        cursor: pointer;
        border-radius: 3px;
        padding: 7px 14px;
        border: 0;
        background-color: inherit;
        text-align: left;
        overflow: hidden;
        width: 100%;
    }
    .menu-list .separator {
        height: 1px;
        background-color: #e2e8f066;
        margin: 5px 0;
    }
    .menu-list button:not(.disabled):hover {
        background-color: var(--menu-color);
        color: var(--menu-background);
    }
    .btn-menu {
        font-size: 20px;
        font-weight: 600;
        width: 36px;
        height: 36px;
        background-color: #6c6b6a;
        /*margin-left: 10px;*/
        border: 0;
        color: white;
        border-radius: 6px;
        cursor: pointer;
    }
    .dropdown {
        display: inline-block;
        position: relative;
    }
</style>
